import React from "react";
import logo from '../assets/logo.png';
import '../css/main.css';
import Breadcrumb from "./Breadcrumb";
export default function Navbar() {
   
  return (
    
    <nav className="container-dash bg-white shadow-2xl px-6  flex items-center justify-between ">
      <div className=" flex">
  <img src={logo} alt="Logo" className="w-18 h-14 object-contain" />
  <Breadcrumb />
</div>

      {/* Right Actions */}
      <div className="flex items-center space-x-4">
        {/* Invite Button */}
        

        {/* Profile */}
        <div className="flex items-center space-x-2">
          <div className="bg-blue-100 text-blue-700 font-medium text-sm px-3  rounded-full">
            Admin
          </div>
          <span className="text-gray-500">🔔</span>
          <span className="text-gray-500">❓</span>
          <span className="text-gray-500">👤</span>
        </div>
      </div>
    </nav>
  );
}
